var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 0V1.33333H1.33333V10.6667H10.6667V4.66667H12V11.3333C12 11.5101 11.9298 11.6797 11.8047 11.8047C11.6797 11.9298 11.5101 12 11.3333 12H0.666667C0.489856 12 0.320286 11.9298 0.195262 11.8047C0.0702379 11.6797 0 11.5101 0 11.3333V0.666667C0 0.489856 0.0702379 0.320286 0.195262 0.195262C0.320286 0.0702379 0.489856 0 0.666667 0H7.33333ZM11.2933 0.236L11.7647 0.707333C11.8272 0.769843 11.8623 0.854612 11.8623 0.943C11.8623 1.03139 11.8272 1.11616 11.7647 1.17867L5.54267 7.4L4.21467 8.05333C4.17717 8.07191 4.13478 8.07826 4.09348 8.07148C4.05218 8.0647 4.01405 8.04514 3.98446 8.01554C3.95486 7.98595 3.9353 7.94782 3.92852 7.90652C3.92174 7.86522 3.92809 7.82284 3.94667 7.78533L4.6 6.45733L10.822 0.235333C10.8845 0.172843 10.9693 0.137738 11.0577 0.137738C11.1461 0.137738 11.2308 0.172843 11.2933 0.235333V0.236Z",
    fill: "#726545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bcff5f32dc0c3b0529e083142ea738ad.svg";
export { ForwardRef as ReactComponent };